const PRE_FIX = 'SPERO_APP_H5_'
export default {
  VIDEO_POPUP: 'VIDEO_POPUP',
  LOGIN_TOKEN: PRE_FIX + 'LOGIN_TOKEN',
  LOGIN_REFRESH: PRE_FIX + 'LOGIN_REFRESH',
  TOPIC_COMMENT_LIKE: PRE_FIX + 'TOPIC_COMMENT_LIKE',
  TOPICVOTE: PRE_FIX + 'TOPICVOTE',
  HOT_THEME_VOTE: PRE_FIX + 'HOT_THEME_VOTE',
  USERINFO: PRE_FIX + 'USERINFO'
}



// WEBPACK FOOTER //
// ./src/constants/storage.js